import { Pipe, PipeTransform } from '@angular/core';
import { AuthJwtService } from '../services/auth-jwt.service';



@Pipe({
  name: 'addtoken'
})
export class AddTokenPipe implements PipeTransform {



  token: string;



  constructor(private authJwtService: AuthJwtService) {
  }



  async transform(value: string): Promise<any> {
    try {
      const res =  this.authJwtService.getToken();
      console.log(res)
      this.token = res;
      return value + '?access_token=' + this.token;
    } catch (error) {
      // Manejo de errores si ocurre algún problema con el Observable convertido en Promesa
      console.error(error);
      // Puedes lanzar una excepción aquí o devolver un valor predeterminado en caso de error.
    }
  }




}